/* Progressive enhancement: one-shot motion, no scroll loop or external library. */
(()=>{
 const init=()=>{
  document.querySelectorAll('[data-lv32-duo]').forEach(form=>{
   if(form.dataset.ready)return;form.dataset.ready='true';
   const submit=form.querySelector('[type=submit]'),initialLabel=submit.textContent;
   window.addEventListener('pageshow',event=>{if(!event.persisted)return;submit.disabled=false;submit.textContent=initialLabel;form.removeAttribute('aria-busy');});
   form.addEventListener('submit',async event=>{
    event.preventDefault();const button=form.querySelector('[type=submit]');if(button.disabled)return;
    const label=button.textContent,status=form.querySelector('[role=status]'),cartLink=form.querySelector('.lv32-check-cart');
    const data=new FormData(form),items=[0,1].map(i=>({id:Number(data.get(`items[${i}][id]`)),quantity:1}));
    if(items.some(item=>!item.id))return;
    button.disabled=true;button.textContent=form.dataset.loading;form.setAttribute('aria-busy','true');status.textContent='';cartLink.hidden=true;
    try{
     const response=await fetch(form.action.replace(/\/$/,'')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
     const result=await response.json();
     if(!response.ok||result.status)throw new Error('cart-add-failed');
     if(!Array.isArray(result.items)||result.items.length!==2)throw new Error('cart-add-unconfirmed');
     window.location.assign(form.dataset.cartUrl);
    }catch(error){status.textContent=form.dataset.failure;cartLink.hidden=false;button.disabled=false;button.textContent=label;form.removeAttribute('aria-busy');}
   });
  });
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window)||!Element.prototype.animate)return;
  const observer=new IntersectionObserver(entries=>{entries.forEach(({target,isIntersecting})=>{
   if(!isIntersecting)return;
   target.animate([{opacity:.65,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'cubic-bezier(.2,.65,.3,1)'});
   if(target.classList.contains('lv31-footer-top')){const glow=target.closest('footer')?.querySelector('.lv32-footer-glow');glow?.animate([{opacity:0,transform:'translateX(0) skewX(-18deg)'},{opacity:1,offset:.3},{opacity:0,transform:'translateX(340%) skewX(-18deg)'}],{duration:2400,easing:'ease-out'});}
   observer.unobserve(target);
  });},{threshold:.12});
  document.querySelectorAll('.lv31-note-group,.lv31-footer-top,.lvr__summary,.lv32-duo').forEach(el=>{if(el.dataset.lv31Motion)return;el.dataset.lv31Motion='true';observer.observe(el);});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
